enum RoleEnum {
  CUSTOMER = "CUSTOMER",
  DPD = "DPD",
  ADMIN = "ADMIN",
  DPD_ADMIN = "DPD_ADMIN",
  GDPR = "GDPR",
  CUSTOMER_COMPANY = "CUSTOMER_COMPANY"
}

const ALL = [
  RoleEnum.CUSTOMER, RoleEnum.CUSTOMER_COMPANY, RoleEnum.DPD, RoleEnum.ADMIN, RoleEnum.GDPR, RoleEnum.DPD_ADMIN
]

const GDPR_ADMIN_GROUP = [RoleEnum.ADMIN, RoleEnum.GDPR]

const DPD_AND_ADMIN = [RoleEnum.DPD, RoleEnum.ADMIN, RoleEnum.DPD_ADMIN]

const WORKFLOW_GROUP = [RoleEnum.CUSTOMER, RoleEnum.DPD, RoleEnum.ADMIN, RoleEnum.DPD_ADMIN]


export {
  RoleEnum,
  ALL,
  DPD_AND_ADMIN,
  WORKFLOW_GROUP,
  GDPR_ADMIN_GROUP
}
